import React from 'react';

export function SSCoinIcon({ size = 24, className = '' }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={`flex-shrink-0 ${className}`}>
      <defs>
        <linearGradient id="coinGold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFD700" />
          <stop offset="30%" stopColor="#FFC107" />
          <stop offset="70%" stopColor="#F59E0B" />
          <stop offset="100%" stopColor="#D97706" />
        </linearGradient>
        <linearGradient id="coinShine" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFF8DC" stopOpacity="0.6" />
          <stop offset="50%" stopColor="#FFD700" stopOpacity="0" />
          <stop offset="100%" stopColor="#FFF8DC" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient id="coinTeal" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2DD4BF" />
          <stop offset="100%" stopColor="#14B8A6" />
        </linearGradient>
        <filter id="coinShadow">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#F59E0B" floodOpacity="0.4" />
        </filter>
      </defs>
      {/* Outer ring */}
      <circle cx="50" cy="50" r="46" fill="url(#coinGold)" filter="url(#coinShadow)" />
      {/* Inner ring border */}
      <circle cx="50" cy="50" r="40" fill="none" stroke="#D97706" strokeWidth="2" opacity="0.5" />
      {/* Inner circle */}
      <circle cx="50" cy="50" r="38" fill="url(#coinGold)" />
      {/* Shine overlay */}
      <circle cx="50" cy="50" r="38" fill="url(#coinShine)" />
      {/* S&S text */}
      <text x="50" y="42" textAnchor="middle" fill="#92400E" fontSize="18" fontWeight="900" fontFamily="Arial, sans-serif">S&S</text>
      {/* Teal accent line */}
      <line x1="28" y1="50" x2="72" y2="50" stroke="url(#coinTeal)" strokeWidth="2.5" strokeLinecap="round" />
      {/* COIN text */}
      <text x="50" y="67" textAnchor="middle" fill="#92400E" fontSize="11" fontWeight="700" fontFamily="Arial, sans-serif" letterSpacing="2">COIN</text>
      {/* Edge dots for decoration */}
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
        <circle key={i} cx={50 + 43 * Math.cos(angle * Math.PI / 180)} cy={50 + 43 * Math.sin(angle * Math.PI / 180)} r="1.5" fill="#D97706" opacity="0.6" />
      ))}
    </svg>
  );
}

export function SSCoinBadge({ amount, size = 'sm', className = '' }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <SSCoinIcon size={size === 'sm' ? 20 : size === 'md' ? 28 : 36} />
      <span className={`font-mono font-bold text-amber-400 ${size === 'sm' ? 'text-sm' : size === 'md' ? 'text-lg' : 'text-2xl'}`}>
        {typeof amount === 'number' ? amount.toLocaleString() : amount}
      </span>
    </div>
  );
}

export default SSCoinIcon;
